import { pr } from '@/utils/pxToRem';
import { Stack } from '@mui/material';
import ImgContainer from '../ImgContainer';

const PartnerWrapper = ({ children }: any) => (
  <div
    className="lazyload"
    style={{
      width: '80px',
      // maxHeight: '34px',
      objectFit: 'contain',
    }}
  >
    {children}
  </div>
);

const GoyoloPartner = () => (
  <Stack spacing={pr`16px`}>
    <Stack
      spacing={pr`23px`}
      flexWrap="wrap"
      justifyContent="space-around"
      direction="row"
    >
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-production/partner-vn.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-production/partner-vj.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-production/partner-qh.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-kumho.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-aa.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-sa.png"
          alt="logo"
        />
      </PartnerWrapper>
    </Stack>
    <Stack
      direction="row"
      flexWrap="wrap"
      justifyContent="space-around"
      spacing={pr`14px`}
    >
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-production/partner-vnr.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-production/partner-ml.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-mq.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-unkow.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-hm.png"
          alt="logo"
        />
      </PartnerWrapper>
      <PartnerWrapper>
        <ImgContainer
          src="https://storage.googleapis.com/goyolo-uat/images/partner-hp.png"
          alt="logo"
        />
      </PartnerWrapper>
    </Stack>
  </Stack>
);

export default GoyoloPartner;
